import { CompleteIcon } from "./CompleteIcon";

export default CompleteIcon;